export const MenuIdInsight = 'INSIGHT' as const;
